import { PlanPriceDto } from '../models/plan.model';

export interface WompiPriceEligibility {
  eligible: boolean;
  reasonKey?: string;
}

export function getWompiPriceEligibility(price: PlanPriceDto | null | undefined): WompiPriceEligibility {
  if (!price) {
    return { eligible: false, reasonKey: 'payments.ineligible.no_price' };
  }
  if (!price.isActive) {
    return { eligible: false, reasonKey: 'payments.ineligible.inactive' };
  }
  if (price.isCustom) {
    return { eligible: false, reasonKey: 'payments.ineligible.custom' };
  }
  if ((price.currencyCode || '').toUpperCase() !== 'COP') {
    return { eligible: false, reasonKey: 'payments.ineligible.currency' };
  }
  if (!Number.isFinite(price.amountInCents) || price.amountInCents <= 0) {
    return { eligible: false, reasonKey: 'payments.ineligible.amount' };
  }
  return { eligible: true };
}
